import {
  ClientType,
  SourcesOfIncome,
} from 'modules/onboarding/common/components';

import { isGlobalProject } from '../../../../config';
import { useTranslation } from '../../../../libs/i18n';
import { useOwnerSourcesOfIncome } from '../hooks';
import { PageComponentProps } from '../types';

export const OwnerSourcesOfIncomeStep = ({ canGoBack }: PageComponentProps) => {
  const {
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
    files,
    onAddFiles,
    onRemoveFile,
    submitDisabled,
  } = useOwnerSourcesOfIncome();

  const { t } = useTranslation();

  return (
    <SourcesOfIncome
      canGoBack={canGoBack}
      clientType={ClientType.Client}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={
        isGlobalProject()
          ? t('onboarding.sourcesOfIncome.ownerSubtitle')
          : undefined
      }
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
